import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Theme picker (Spec 7.1; indicator reworked 2026-07-26 on owner feedback).
 * One row per theme with a RADIO-style indicator — ring + inner dot on the active
 * one — rather than a colour swatch plus a far-right checkmark. Slots into the
 * Navbar profile dropdown (7.2 migrates the whole dropdown to DS components).
 */
const ThemeToggle: React.FC = () => {
  const { theme, setTheme, themes } = useTheme();

  return (
    <>
      <div className="px-4 pt-2 pb-1 text-10 font-semibold uppercase tracking-wide text-slate-500">
        Theme
      </div>
      {themes.map((t) => (
        <button
          key={t.id}
          onClick={() => setTheme(t.id)}
          aria-pressed={t.id === theme}
          className="w-full flex items-center gap-2 px-4 py-2 text-sm text-slate-300 hover:bg-slate-700/50 hover:text-white transition-colors"
        >
          {/* Radio-style indicator, not a swatch + trailing check. Both v1 themes are
              near-black (#090d18 / #070809), so a plain colour dot reads as an unchecked
              radio and the real state lived all the way over on the right. The ring +
              inner dot puts the selection where the eye already looks. */}
          <span
            className={`w-4 h-4 rounded-full border-2 shrink-0 flex items-center justify-center
                        transition-colors ${t.id === theme ? 'border-green-400' : 'border-slate-600'}`}
            style={{ background: t.swatch }}
          >
            {t.id === theme && <span className="w-1.5 h-1.5 rounded-full bg-green-400" />}
          </span>
          <span className="flex-1 text-left">{t.label}</span>
        </button>
      ))}
    </>
  );
};

export default ThemeToggle;
